import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { getCurrentPaginatorPage } from './helpers';
import * as UILocale from '../../../utils/UILocale';
import * as UISettings from '../../../utils/UISettings';
import translations from './translations';
import ProductsGridRow from './components/ProductGridRow';
import { ProductListBlock } from './components/ProductList';
import {
  SponsoredProductsBlock,
  SponsoredProductsResource,
  LoadBeacon,
  withDataLayer,
  withViewBeacon,
  withDuplicityProductsRemover,
  withPositionManager
} from './components/SponsoredProducts';
import { compose } from '../utils/fp';


export default function initSponsoredProducts(productsGridView, productsListView) {
  const sponsoredProductsElement = document.querySelector('[data-component="sponsored-products"]');
  const dataInteraction = 'hookLogic';
  const label = UILocale.getString('component.hooklogic.sponsored-products');
  const activeView = window.appState.getState().listingPage.pageSetup.viewSwitch;
  const productsView = activeView === 'list' ? productsListView : productsGridView;
  const minProductsCount = 4;

  if (sponsoredProductsElement &&
    isFeatureEnabled() &&
    isOnFirstPage() &&
    hasOrderByDefault() &&
    hasNotUsedFilters()
  ) {
    const EnhancedProductGridRow = compose(
      withDataLayer,
      withViewBeacon
    )(ProductsGridRow);

    const EnhancedProductListRow = compose(
      withDataLayer,
      withViewBeacon
    )(ProductListBlock);

    const EnhancedSponsoredProductsBlock = compose(
      withPositionManager,
      withDuplicityProductsRemover
    )(SponsoredProductsBlock);

    ReactDOM.render(
      <Provider store={window.appState}>
        <SponsoredProductsResource
          segmentId={window.digitalData.page.category.segmentId}
          onLoaded={showSponsoredProducts(sponsoredProductsElement, minProductsCount)}
        >
          {(sponsoredProducts, loadBeaconUrl) => (
            <React.Fragment>
              <LoadBeacon loadBeaconUrl={loadBeaconUrl} />
              {sponsoredProducts.length >= minProductsCount &&
              <EnhancedSponsoredProductsBlock
                productsView={productsView}
                sponsoredProducts={sponsoredProducts}
                productsGridRow={
                  <EnhancedProductGridRow
                    rowProductsList={sponsoredProducts}
                    translations={translations}
                    dataInteraction={dataInteraction}
                  />
                }
                productsListRow={
                  <EnhancedProductListRow
                    productsList={sponsoredProducts}
                    dataInteraction={dataInteraction}
                  />
                }
                activeView={activeView}
                sponsoredProductsLabel={label}
              />
              }
            </React.Fragment>
          )}
        </SponsoredProductsResource>
      </Provider>,
      sponsoredProductsElement
    );
  } else {
    window.appState.dispatch({
      type: 'COUNT_SPONSORED_PRODUCTS',
      payload: 0
    });

    if (sponsoredProductsElement) {
      sponsoredProductsElement.parentNode.removeChild(sponsoredProductsElement);
    }
  }
}

function isOnFirstPage() {
  const currentPaginatorPage = getCurrentPaginatorPage();
  return currentPaginatorPage && currentPaginatorPage.label === 1;
}

function hasOrderByDefault() {
  const sortOptionLabel = window.appState.getState()
    .listingPage.pageSetup.sortByOptions.optionsList[0].translation;
  return window.digitalData.page.rankMethod &&
    window.digitalData.page.rankMethod === sortOptionLabel;
}

function hasNotUsedFilters() {
  return window.digitalData.page.refinement && window.digitalData.page.refinement.length === 1;
}

function isFeatureEnabled() {
  return UISettings.get('component.hooklogic.enabled');
}

function showSponsoredProducts(element, minProductsCount) {
  return function loaded(sponsoredProducts) {
    if (sponsoredProducts.length >= minProductsCount) {
      // eslint-disable-next-line no-param-reassign
      element.style.display = 'block';
    }
  };
}
